import { createSelector } from 'reselect'
import { CspSessionType } from 'src/app/CspSignin/redux/cspSignin.reducer'
import { RootState } from 'src/redux/createRootReducer'
import {
  selectCspUserListModelsFromState,
  selectUserListModelsFromState,
} from 'src/redux/selectors/data/users.selectors'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectIsLookingUpFromState = (state: RootState): boolean =>
  state.app.cspSignin.isLookingUp
export const selectIsVerifyingUserFromState = (state: RootState): boolean =>
  state.app.cspSignin.isVerifyingUser
export const selectVerificationEmailResentFromState = (
  state: RootState,
): boolean => state.app.cspSignin.verificationEmailResent
export const selectResendVerificationTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.cspSignin.resendVerificationTopLevelError
export const selectVerifyEmailTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.cspSignin.verifyEmailTopLevelError
export const selectIsCspLoggingInFromState = (state: RootState): boolean =>
  state.app.cspSignin.isCspLoggingIn
export const selectCspLoginTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.cspSignin.cspLoginTopLevelError
export const selectCspLoginErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.cspSignin.cspLoginErrorDetailMap
export const selectLookupTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.cspSignin.lookupTopLevelError
export const selectLookupErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.cspSignin.lookupErrorDetailMap
export const selectSelectedCspSessionType = (
  state: RootState,
): CspSessionType | undefined => state.app.cspSignin.selectedCspSessionType
export const selectIsPostingCspEmulatedSessionsOfflineFromState = (
  state: RootState,
): boolean => state.app.cspSignin.isPostingCspEmulatedSessionsOffline
export const selectPostingCspEmulatedSessionsOfflineTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.cspSignin.postCspEmulatedSessionsOfflineTopLevelError
export const selectPostingCspEmulatedSessionsOfflineErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.cspSignin.postCspEmulatedSessionsOfflineErrorDetailMap
export const selectIsPostingCspEmulatedSessionsLiveFromState = (
  state: RootState,
): boolean => state.app.cspSignin.isPostingCspEmulatedSessionsLive
export const selectPostingCspEmulatedSessionsLiveTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.cspSignin.postCspEmulatedSessionsLiveTopLevelError
export const selectPostingCspEmulatedSessionsLiveErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.cspSignin.postCspEmulatedSessionsLiveErrorDetailMap
export const selectIsPuttingCspEmulatedSessionsVerifyFromState = (
  state: RootState,
): boolean => state.app.cspSignin.isPuttingCspEmulatedSessionsVerify
export const selectPuttingCspEmulatedSessionsVerifyTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.cspSignin.putCspEmulatedSessionsVerifyTopLevelError
export const selectPuttingCspEmulatedSessionsVerifyErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.cspSignin.putCspEmulatedSessionsVerifyErrorDetailMap
export const selectUserSessionTokenIdFromState = (
  state: RootState,
): string | undefined => state.app.cspSignin.userSessionTokenId
export const selectHasSentTokenFromState = (state: RootState): boolean =>
  state.app.cspSignin.hasSentToken
export const selectUserIdFromState = (state: RootState): string | undefined =>
  state.app.cspSignin.userId
export const selectUserListModelFromState = createSelector(
  [selectUserIdFromState, selectUserListModelsFromState],
  (id, users) => (id !== undefined ? users[id] : undefined),
)
export const selectCspUser = createSelector(
  [selectCspUserListModelsFromState, selectUserIdFromState],
  (users, userId) => {
    return userId ? users[userId] : undefined
  },
)
